module.exports = __webpack_public_path__ + "static/media/digitale-doerfer-logo@2x.0386d45f.png";